<template>
  <router-view />
</template>

<style lang="less">
@import "./assets/style/base";
@import "./assets/style/layout";
</style>
